import {
  GET_DISCORD_INFO,
  getDiscordInfoSuccess,
  getDiscordInfoError,
} from "store/actions/index";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

export const fetchDiscordDataEpic = (action$, _, { request }) =>
  action$.pipe(
    ofType(GET_DISCORD_INFO),
    switchMap(() =>
      request(
        "https://discordapp.com/api/v6/invite/vHaSEjV?with_counts=true"
      ).pipe(
        map(({ response }) => getDiscordInfoSuccess(response)),
        catchError((err) => of(getDiscordInfoError(err)))
      )
    )
  );
